import { render, staticRenderFns } from "./dados-cadastrais.vue?vue&type=template&id=6f893948&scoped=true"
import script from "./dados-cadastrais.vue?vue&type=script&lang=js"
export * from "./dados-cadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f893948",
  null
  
)

export default component.exports